// ── 출퇴근 윗부분 가운데 [‹ 2026년 10월 ›][오늘] — 달력 탭과 직원별 상세 탭이 같이 쓴다 (2026-10-13) ─────
//   사용자 "출퇴근관리에 출퇴근 달력처럼 상단에 월표시와 버튼 추가해서 이동 할 수 있게해줘" → (가) 필터 창의 년/월 고르기는 없앴다.
//   달력 윗줄(attendancecalendar/ControlBar)에 있던 것을 **그대로** 옮겼다 — 모양·크기 같음.
//   날짜 글자는 줄 정확히 한가운데, [오늘]은 그 오른쪽 옆(2026-09-30): 빈칸 · 날짜 넘기기 · 오늘 3칸, 양쪽 칸이 같은 폭(1fr).
//   휴대폰은 줄 폭 전체를 쓴다. 좁은 폰에서 오늘이 칸보다 넓으면 칸이 늘어 몇 px 밀릴 뿐 넘치지 않는다.
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { stdOutlineBtn } from '../adminlayout/designStandard';

// 달 넘기기 버튼: 24×24 정사각형 + ‹ › (2026-09-30 사용자 "네모 정사각형으로, 크기 줄여줘" — 전: 38×21 ◀▶)
//   [오늘]·주 넘기기도 같은 높이 24, 글자 11px 로 맞춘다(전: 오늘 51×37).
export const navSmallBtn = {
  ...stdOutlineBtn, height: 24, boxSizing: 'border-box', borderRadius: 6, fontSize: 11,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 2, padding: '0 8px',
};
export const navSquareBtn = { ...navSmallBtn, width: 24, padding: 0 };

/** 가운데 줄 틀: 빈칸 · children(넘기기) · [오늘]. 달력 주별(PC)도 이 틀을 쓴다. */
export function NavCenterRow({ isMobile, todayButton, children }) {
  return (
    <div style={{ width: isMobile ? '100%' : undefined, display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', columnGap: 8 }}>
      <span aria-hidden="true" />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{children}</div>
      <div style={{ justifySelf: 'start' }}>{todayButton}</div>
    </div>
  );
}

export function TodayButton({ onClick }) {
  return <button type="button" onClick={onClick} style={navSmallBtn}>오늘</button>;
}

/**
 * [‹ 2026년 10월 ›][오늘]
 * @param {boolean} props.isMobile
 * @param {number}  props.year / props.month
 * @param {(delta:number)=>void} props.onMoveMonth   -1 지난달 / +1 다음 달
 * @param {()=>void} props.onToday                     이번 달로
 */
export default function AttendanceMonthNav({ isMobile, year, month, onMoveMonth, onToday }) {
  return (
    <NavCenterRow isMobile={isMobile} todayButton={<TodayButton onClick={onToday} />}>
      <button type="button" aria-label="이전 달" onClick={() => onMoveMonth(-1)} style={navSquareBtn}>
        <ChevronLeft size={15} aria-hidden="true" />
      </button>
      <span style={{ fontSize: 22, fontWeight: 800, minWidth: 120, textAlign: 'center' }}>{year}년 {month}월</span>
      <button type="button" aria-label="다음 달" onClick={() => onMoveMonth(1)} style={navSquareBtn}>
        <ChevronRight size={15} aria-hidden="true" />
      </button>
    </NavCenterRow>
  );
}
